import { createFileRoute } from '@tanstack/react-router';
import { PaginaEmDesenvolvimento } from '@/components/layout/PaginaEmDesenvolvimento';

export const Route = createFileRoute('/_admin/campanhas')({
  component: CampanhasPage,
});

function CampanhasPage() {
  return <PaginaEmDesenvolvimento label="Campanhas" />;
}
